import React from "react"

import { WithLoadingIndicator } from "~tailwindui/Basics"

import { gql, useQuery } from "hooks/urql"

import LocalTime from "components/LocalTime"

const AudioRoomIndex: React.FC = () => {
  const [result] = useQuery({ query: audioRoomsQuery })

  return (
    <div className="m-6">
      <WithLoadingIndicator result={result}>
        {({ data }) =>
          data.audioRooms.length === 0 ? (
            <p className="italic text-gray-500">No audio rooms</p>
          ) : (
            <ul className="divide-y divide-gray-200">
              {data.audioRooms.map(audioRoom => (
                <li
                  key={audioRoom.id}
                  className="flex items-center justify-between py-3"
                >
                  <span>
                    Room #{audioRoom.id} - created by{" "}
                    {audioRoom.createdBy.fullName} on{" "}
                    <LocalTime timestamp={audioRoom.createdAt} />
                  </span>
                  <a
                    href={audioRoom.showPath}
                    className="btn btn-info btn-sm"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Join
                  </a>
                </li>
              ))}
            </ul>
          )
        }
      </WithLoadingIndicator>
    </div>
  )
}

const audioRoomsQuery = gql`
  query AudioRoomIndex {
    audioRooms {
      id
      showPath
      createdAt
      createdBy {
        id
        fullName
      }
    }
  }
`

export default AudioRoomIndex
